export default {
    path: 'footer',
    component: () => import('../Footer.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Chân trang',
            component: () => import('../../table/Table.vue'),
        },
        {
            path: 'desktop/:id',
            name: 'Chân trang cho máy tính',
            component: () => import('../../cu/CU.vue'),
        },
        {
            path: 'mobile/:id',
            name: 'Chân trang cho di động',
            component: () => import('../../cu/CU.vue'),
        },
    ]
};